import Event from '../../core/Event';
import { RowType } from '../../../view/order/removeRowsWithoutOrder';

export default class OrderImportRequested extends Event {
    public static type = 'OrderImportRequested';

    constructor(public readonly rows: RowType[][]) {
        super(OrderImportRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderImportRequested.ts